import React, { FC, memo } from 'react';
import classNames from 'classnames';

import FileTextIcon from '@zvuk-b2b/react-uikit/ui/icons/FileTextFilled';

import { TEXTS } from './texts';
import { InvoiceContentProps, InvoiceContentSize } from './types';

import styles from './index.module.scss';

const InvoiceContent: FC<InvoiceContentProps> = ({ className, size = InvoiceContentSize.MEDIUM }) => (
  <div
    className={classNames(styles.content, className, {
      [styles.contentSmall]: size === InvoiceContentSize.SMALL,
    })}>
    <FileTextIcon
      className={classNames(styles.icon, {
        [styles.iconSmall]: size === InvoiceContentSize.SMALL,
      })}
    />
    <div className={styles.text}>{TEXTS.INVOICE_TEXT}</div>
  </div>
);

export default memo(InvoiceContent);
